import React, { useState, useEffect } from 'react';
import { GET_PAYMENTUS_XOTP_URL, PAY_WITH_PAYMENTUS_SAVED_PAYMENT_METHOD } from 'requests';
import { PaymentButton } from '../Checkout';
import PlusIcon from '@tecuity/sos-icons/react/plus-heavy';
import { PaymentusIframeModal } from './PaymentusIframeModal';

export const PaymentusSavedPayment = ({
    ProviderType,
    startPayment,
    redirectToReceipt,
    receiptItemGuids
}) => {

    const [iframeUrl, setIframeUrl] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [savedPaymentMethodId, setSavedPaymentMethodId] = useState(null);

    const handleIframeClose = () => {

        setIframeUrl(null);
        setIsLoading(true);
    };

    useEffect(() => {

        const handleMessage = (event) => {

            if (event.data.paymentMethodId) {
                
                setSavedPaymentMethodId(event.data.paymentMethodId)
                handleIframeClose();
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };

    }, []);

    const addSavedPaymentMethodWithPaymentus = () => {

        setSavedPaymentMethodId(null);

        GET_PAYMENTUS_XOTP_URL(
            (response) => {
                setIframeUrl(response.url || response);
            },
            (error) => {
                console.error(error);
            }
        );
    };

    const handleCheckout = () => {

        setIsLoading(true);

        try {
            startPayment(checkoutWithPaymentusSavedPaymentMethod);
        } finally {
            setIsLoading(false);
        }
    };

    const checkoutWithPaymentusSavedPaymentMethod = () => {

        PAY_WITH_PAYMENTUS_SAVED_PAYMENT_METHOD(
            {
                ItemIds: receiptItemGuids,
                PaymentMethodId: savedPaymentMethodId
            },
            (refNum) => {
                redirectToReceipt(refNum);
            },
            (err) => {
                console.error(err);
            }
        );
    };

    return (
        <React.Fragment key={ProviderType}>
            <button
                className="add-button payment-button btn-3d button"
                onClick={addSavedPaymentMethodWithPaymentus}
            >
                <div className="center">
                    <PlusIcon /> Add or Edit Payment Method
                </div>
            </button>

            {savedPaymentMethodId && (
                <PaymentButton
                    onClick={handleCheckout}
                    isLoading={isLoading}
                >
                    Checkout
                </PaymentButton>
            )}

            <PaymentusIframeModal
                iframeUrl={iframeUrl}
                onClose={handleIframeClose}
            />

        </React.Fragment>
    );
};
